import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = {
  key: 0,
  style: {"height":"calc(100vh - 300px)"}
}
const _hoisted_5 = {
  key: 0,
  class: "px-3 py-1"
}
const _hoisted_6 = { class: "p-field-label my-2" }
const _hoisted_7 = { style: {"margin":"0 -0.5rem"} }
const _hoisted_8 = {
  class: "checkbox-sublabel text-gray",
  style: {"font-size":"13px"}
}
const _hoisted_9 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_10 = {
  key: 0,
  class: "px-3 py-1"
}
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "d-flex align-items-center mb-2" }
const _hoisted_13 = { class: "p-field-label mb-0" }
const _hoisted_14 = { class: "ml-auto" }
const _hoisted_15 = { class: "p-field-label small" }
const _hoisted_16 = {
  key: 0,
  class: "separator mt-3 mb-4",
  style: {"background-color":"currentColor","opacity":"0.25"}
}
const _hoisted_17 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_18 = {
  key: 0,
  class: "px-3 py-1"
}
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "text-gray small mb-2" }
const _hoisted_21 = { class: "ml-auto" }
const _hoisted_22 = { class: "text-uppercase text-gray small" }
const _hoisted_23 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_ListItemCheck = _resolveComponent("ListItemCheck")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_NumberButtons = _resolveComponent("NumberButtons")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.pageTitle), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", {
        style: [{"display":"grid","gap":"2rem"}, { gridTemplateColumns: _ctx.uniqueLinkingMode ? '1fr 1fr' : '0.8fr 0.8fr 0.8fr' }]
      }, [
        (!_ctx.uniqueLinkingMode)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
                default: _withCtx(() => [
                  (_ctx.currentBuilding)
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        _createVNode("label", {
                          class: "p-field-label mt-1",
                          for: `buildingName${_ctx.currentBuildingIndex}`
                        }, _toDisplayString(_ctx.buildingName(_ctx.currentBuildingIndex + 1)), 9, ["for"]),
                        _createVNode(_component_InputText, {
                          id: `buildingName${_ctx.currentBuildingIndex}`,
                          type: "text",
                          modelValue: _ctx.currentBuilding.name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentBuilding.name = $event)),
                          class: "mb-3"
                        }, null, 8, ["id", "modelValue"]),
                        _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("AppResourceEP.AssociateRisersBackboneWithBuilding")), 1),
                        _createVNode("div", _hoisted_7, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableRiserOptions, (riserOption, index) => {
                            return (_openBlock(), _createBlock(_component_ListItemCheck, {
                              key: riserOption.riserId,
                              label: riserOption.riserName,
                              value: riserOption.riserId,
                              inputId: `building${_ctx.currentBuildingIndex}Riser${riserOption.riserId}`,
                              name: "riserLinkSelection",
                              modelValue: _ctx.currentBuilding.linkedRisersIds,
                              "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentBuilding.linkedRisersIds = $event)),
                                _cache[3] || (_cache[3] = ($event: any) => (_ctx.onLinkedRisersChange(_ctx.currentBuildingIndex, $event)))
                              ],
                              disabled: _ctx.isRiserDisabledForBuilding(_ctx.currentBuildingIndex, riserOption.riserId),
                              last: index == _ctx.availableRiserOptions.length-1
                            }, _createSlots({ _: 2 }, [
                              (riserOption.interfacesComboMode !== '')
                                ? {
                                    name: "checkbox-sublabel",
                                    fn: _withCtx(() => [
                                      _createVNode("div", _hoisted_8, [
                                        _createVNode("small", null, _toDisplayString(riserOption.interfacesComboMode), 1)
                                      ])
                                    ])
                                  }
                                : undefined
                            ]), 1032, ["label", "value", "inputId", "modelValue", "disabled", "last"]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
            default: _withCtx(() => [
              (_ctx.currentBuilding)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode("h6", _hoisted_11, _toDisplayString(_ctx.currentBuilding.name), 1),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentBuilding.linkedRisersConfig, (riser, riserIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        key: riser.id,
                        class: "mb-4"
                      }, [
                        (riser.id)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _createVNode("div", _hoisted_12, [
                                _createVNode("label", _hoisted_13, _toDisplayString(riser.name), 1),
                                _createVNode("div", _hoisted_14, [
                                  _createVNode(_component_NumberButtons, {
                                    modelValue: _ctx.riserFloorConfigs.get(riser.id)?.floorsCount || 0,
                                    minValue: 0,
                                    disableDecrease: !(_ctx.riserFloorConfigs.get(riser.id)?.floorsCount),
                                    onIncrement: ($event: any) => (_ctx.addFloor(riser.id)),
                                    onDecrement: ($event: any) => (_ctx.removeFloor(riser.id, (_ctx.riserFloorConfigs.get(riser.id)?.floors.length || 1) - 1))
                                  }, null, 8, ["modelValue", "disableDecrease", "onIncrement", "onDecrement"])
                                ])
                              ]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.riserFloorConfigs.get(riser.id)?.floors || [], (floor, floorIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: floor.id,
                                  class: "mb-3"
                                }, [
                                  _createVNode("label", _hoisted_15, _toDisplayString(_ctx.floorName(floorIndex + 1)), 1),
                                  _createVNode(_component_InputText, {
                                    modelValue: floor.name,
                                    "onUpdate:modelValue": ($event: any) => (floor.name = $event),
                                    class: "w-100",
                                    placeholder: `${_ctx.$t('AppResourceEP.Floor')} ${floorIndex + 1}`
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                ]))
                              }), 128)),
                              (riserIndex < _ctx.currentBuilding.linkedRisersConfig.length - 1)
                                ? (_openBlock(), _createBlock("hr", _hoisted_16))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
            default: _withCtx(() => [
              (_ctx.currentBuilding)
                ? (_openBlock(), _createBlock("div", _hoisted_18, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentBuilding.linkedRisersConfig, (riser) => {
                      return (_openBlock(), _createBlock("div", {
                        key: riser.id,
                        class: "mb-4"
                      }, [
                        (riser.id)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _createVNode("h6", _hoisted_19, _toDisplayString(riser.name), 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.riserFloorConfigs.get(riser.id)?.floors || [], (floor) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: floor.id,
                                  class: "mb-3 d-flex"
                                }, [
                                  _createVNode("div", _hoisted_20, _toDisplayString(floor.name), 1),
                                  _createVNode("div", _hoisted_21, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(floor.apartmentDistribution, (distribution) => {
                                      return (_openBlock(), _createBlock("div", {
                                        key: distribution.interfaceId,
                                        class: "mb-2 d-flex flex-column"
                                      }, [
                                        _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('AppResourceEP.Apartments')) + " (" + _toDisplayString(_ctx.getInterfaceModeLabel(riser.interfaces.find(i => i.id === distribution.interfaceId)?.mode)) + ") ", 1),
                                        _createVNode(_component_Dropdown, {
                                          options: _ctx.apartmentCountValues(riser, distribution.interfaceId, floor.id),
                                          optionLabel: "label",
                                          optionValue: "value",
                                          optionDisabled: "disabled",
                                          modelValue: distribution.count,
                                          onChange: (e) => _ctx.changeApartmentDistributionCount(distribution, e)
                                        }, null, 8, ["options", "modelValue", "onChange"])
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              }), 128))
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ], 4)
    ]),
    _createVNode("footer", _hoisted_23, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackButton,
        label: _ctx.$t('AppResource.Back'),
        class: "p-button-text mr-3"
      }, null, 8, ["onClick", "label"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleNextButton,
        disabled: _ctx.isNextDisabled,
        label: _ctx.nextButtonLabel,
        class: "p-button-rounded p-button-raised p-button--m"
      }, null, 8, ["onClick", "disabled", "label"])
    ])
  ], 64))
}